
import * as React from "react";
import {SmallSpinner} from "./SmallSpinner.tsx";

interface Props {
    title: string,
    ariaLabel?: string,
    onClick: () => void,
    className?: string,
    icon?: React.ElementType<{ className?: string }>;
    disabled?: boolean;
    loading?: boolean;
    type?: "button" | "submit" | "reset";
    tooltip?: string;
}

export function SecondaryButton(props: Props) {
    const baseButtonStyles = "rounded-md px-2.5 py-1.5 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 flex items-center gap-1.5 ";
    const enabled = "bg-white text-gray-900 shadow-sm";
    const disabledStyles = "bg-gray-50 text-gray-700 shadow-sm cursor-not-allowed";

    const finalStyles = `${baseButtonStyles} ${props.disabled || props.loading ? disabledStyles : enabled} ${props.className || ""}`;

    return (
        <button
            type={props.type || "button"}
            aria-label={props.ariaLabel ?? props.title}
            title={props.tooltip}
            onClick={!props.loading && !props.disabled ? props.onClick : () => {}}
            disabled={props.disabled || props.loading}
            className={finalStyles}
            aria-busy={props.loading}
        >
            {props.loading ? (
                <SmallSpinner />
            ) : (
                props.icon ? <props.icon className='h-5 w-5 mb-0.5' /> : null
            )}
            <span>{props.title}</span>
        </button>
    );
}
